import { Link } from "react-router-dom";

const PipsTradeAppContentThree = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Trade Anytime, Anywhere</h2>
              <p>
                Available on both iOS and Android, The Pips Trade App gives you
                complete access to global markets, account management, and
                trading analytics in a few taps. Stay ahead of the markets
                whether you’re on the train, in a meeting, or at home.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Download for iOS / Android
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={process.env.PUBLIC_URL + "/images/platforms/pips_trade_app/trade_app_2.png"}
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PipsTradeAppContentThree;
